import {
  List,
  Datagrid,
  TextField,
  NumberField,
  BooleanField,
} from "react-admin";

export const GameConfigList = () => (
  <List perPage={50}>
    <Datagrid bulkActionButtons={false}>
      <TextField
        source="id"
        label="ID"
        sx={{ fontFamily: "'JetBrains Mono', monospace", fontSize: "0.8rem" }}
      />
      <TextField source="operatorId" label="Operator" />
      <TextField source="currencyCode" label="Currency" />
      <NumberField source="maxBetsPerUser" label="Max Bets" />
      <NumberField
        source="minBet"
        label="Min Bet"
        options={{ minimumFractionDigits: 2 }}
      />
      <NumberField
        source="maxBet"
        label="Max Bet"
        options={{ minimumFractionDigits: 2 }}
      />
      <NumberField
        source="maxWinAmount"
        label="Max Win"
        options={{ minimumFractionDigits: 2 }}
      />
      <BooleanField source="hasMoreOptions" label="More Options" />
    </Datagrid>
  </List>
);
